import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1rem;
  margin-bottom: 1rem;
`;

export const TruckIcon = styled.img`
  cursor: pointer;
`;

export const TableHeaderContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  padding: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.55rem;
`;

export const SelectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 50%;
  margin-right: 0.5rem;
  margin-bottom: 1rem;
  & > span {
    font-size: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 0;
  }
`;

export const TableContainer = styled.div`
  & .truck-btn-cancel-order {
    justify-content: center;
    display: flex;
  }
  & .truck-btn-cancel-order > .hefesto-button {
    padding: 0;
  }
`;
